import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=2a58e285"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a58e285')) {
      api.createRecord('2a58e285', component.options)
    } else {
      api.reload('2a58e285', component.options)
    }
    module.hot.accept("./Page404.vue?vue&type=template&id=2a58e285", function () {
      api.rerender('2a58e285', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Page404.vue"
export default component.exports